<!-- HTML -->
<template>
  <div>

    <section class="hero is-fullheight">
      <div class="text-container">
        <div class="title-box">
          <h1 class="title is-3">
            Get 15% off at our <a href="https://jugemscloud.bandcamp.com/" target="_blank" class="store-link">Store!</a>
          </h1>
          <h3 class="subtitle is-5">
            Receive exclusive news and Store offers for great Jugem's Cloud merch!
          </h3>
        </div>
        <!-- Join Button -->
        <a href="https://mailchi.mp/42d7c1d60927/15-off" target="_blank">
          <div class="join-button">
            <h3 class="subtitle is-5">
              Subscribe
            </h3>
          </div>
        </a>
      </div>
    </section>

  </div>
</template>

<!-- JavaScript -->
<script>

export default {

  name: "HomeMailingList"

};

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

h1, h3 {
  font-family: astera;
  color: $green-tint-2;
}
p {
  font-family: astera;
}
a {
  color: $green-tint-2;
}
a:hover {
  color: $green-tint-1;
}
.store-link {
  text-decoration: underline;
}

.hero {
  background: url("../../assets/img/home/industrial-basement.jpg") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.text-container {
  position: relative;
  height: 100vh;
  width: 100vw;
}
.title-box {
  position: absolute;
  left: 6rem;
  bottom: 12rem;
}
.join-button {
  position: absolute;
  max-width: 50%;
  left: 6rem;
  bottom: 6rem;
  padding: 1rem;
  background-color: $green-tint-2;
}
.join-button:hover {
  background-color: $green-tint-1;
  cursor: pointer;
}
.join-button h3 {
  color: black;
}
/* Media Queries */
@media screen and (max-width: 512px) {
  .email-form input {
    font-size: 1.2rem;
  }
}
@media all and (min-width: 513px) and (max-width: 640px) {
  .email-form input {
    font-size: 1.6rem;
  }
}
@media all and (min-width: 641px) and (max-width: 768px) {
  .email-form input {
    font-size: 2rem;
  }
}
@media all and (min-width: 769px) and (max-width: 896px) {
  .email-form input {
    font-size: 2.5rem;
  }
}
@media screen and (max-width: 512px) {
  .title-box, .join-image, .join-button {
    left: 2rem;
  }
}

</style>
